<template>

    <v-dialog v-model="dialogModel" max-width="400">

        <!-- TOOLBAR -->
        <toolbar-page title="Please select nominations">
            <template slot="buttons">

                <v-tooltip color="primary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn @click="closeDialog()" class="mr-1" icon small color="white" v-on="on">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Cancel</span>
                </v-tooltip>
            </template>
        </toolbar-page>

        <!-- CARD BODY -->
        <v-card class="pt-4">
            <v-card-text class="pb-0">

                <v-alert type="info" class="body-2 mb-0">Please select the nominations your would like to offer
                </v-alert>

                <v-container>

                    <!-- NOMINATIONS -->
                    <v-row dense>
                        <v-col cols="6"
                               v-for="nomination in availableNominations"
                               :key="nomination.value"
                               class="pt-2 pr-2">

                            <v-btn width="100%" :color="nomination.selected ? 'primary' : 'secondary'"
                                   @click="nomination.selected = !nomination.selected">
                                {{nomination.value}} {{currency}}
                            </v-btn>

                        </v-col>
                    </v-row>

                </v-container>

                <!-- BUTTONS -->
                <v-card-text>
                    <v-container fluid class="pa-0">
                        <v-row no-gutters>
                            <v-col cols="6" class="text-left">
                                <v-btn
                                       @click="doneClicked"
                                       color="primary">Select
                                </v-btn>
                            </v-col>
                            <v-col cols="6" class="text-right">
                                <v-btn @click="cancelClicked" text>
                                    Cancel
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

    import {mapState, mapActions} from "vuex";
    import ToolbarPage from "../../../../components/UI/ToolbarPage";

    const vuexModule = "Rewards";
    const limitCurrencies = ['USD', 'GBP', 'EUR'];

    export default {

        components: {
            ToolbarPage
        },

        props: {
            value: {
                required: true,
                type: Boolean,
            },
            rewards: {
                required: true,
                type: Array
            },
            currencies: {
                required: true,
                type: Array
            },
            currency: {
                required: true,
                type: String,
            }
        },

        data() {
            return {
                selectedModel: [],
                nominations: [
                    {value: 1, selected: false},
                    {value: 5, selected: false},
                    {value: 10, selected: false},
                    {value: 20, selected: false},
                    {value: 50, selected: false},
                    {value: 100, selected: false},
                    {value: 200, selected: false},
                    {value: 500, selected: false},
                    {value: 1000, selected: false},
                ]
            }
        },

        computed: {

            ...mapState(vuexModule, [
                'payPalRewards',
                'payPalCurrencies'
            ]),

            dialogModel: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            },

            minValue() {
                if (this.item.minValue < 1) return 1;
                return this.item.minValue;

            },
            maxValue() {
                if (limitCurrencies.includes(this.currency)) {
                    return 200;
                }
                return 1000;
            },

            availableNominations() {

                let nominations = [...this.nominations];

                nominations.forEach(nomination => {
                    const index = this.rewards.findIndex(reward => {

                        return reward.cost === nomination.value && reward.cost_currency === this.currency;
                    });

                    // Select if found
                    nomination.selected = index !== -1;
                });

                // Sort so that things appears in value order
                nominations.sort((a, b) => {
                    if (a.value < b.value) return -1;
                    if (a.value > b.value) return 1;
                });

                return nominations.filter(item => item.value <= this.maxValue);
            },
        },

        methods: {

            ...mapActions(vuexModule, [
                'getPayPalCurrencies'
            ]),

            closeClicked() {
                this.$emit('input', false);
            },

            closeDialog() {
                this.$emit('input', false);
            },

            doneClicked() {

                const values = this.availableNominations
                    .filter(nomination => nomination.selected)
                    .map(nomination => nomination.value);

                this.$emit('change', values);
                this.closeDialog()
            },

            cancelClicked() {
                this.selected = [];
                this.closeDialog();
            },
        },
    };
</script>
